<template>
    <v-card flat v-if="lists && lists.length > 0 && taskNotes.length > 0">
        <v-card-text>
            <div class="form-box-title">{{ $t("Направлено_к_сведению") }}</div>
            <v-row class="full-width-row" no-gutters>
                <v-col cols="12" sm="12" md="2">
                    <label class="f-label">{{ $t("Направлено_к_сведению") }}</label>
                </v-col>
                <v-col  cols="12" sm="12" md="10">
                    <div class="icon-click-row-group">
                        <div class="onlyReadData more-per-lab-wrap">
                            <template v-for="(executer, i) in taskNotes" >
                                <v-workplace-chip
                                    :key="i"
                                    :id="executer.workplaceId"
                                    :name="executer.name"
                                    :iconColor="executer.signDate ? '#43B581' : null"
                                    :is-employee="true"
                                    :toolTipText="executer.toolTipText"
                                />
                            </template>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "TakeNoteListCardPanel",
    props: {
        lists: {
            type: Array,
            default: null
        }
    },
    computed: {
        taskNotes() {
            return this.lists.flatMap(list => 
                list.Records.map(member => ({
                    name: member.SignerName,
                    workplaceId: member.SignerID, 
                    employeeId: member.SignerEmployeeID,
                    beginDate: member.BeginDate,
                    signDate: member.SignDate,
                    toolTipText: `${this.$t('Направлен')}: ${this.formatDate(member.BeginDate)} (${list.InitiatorName})${(member.SignDate ? `<br>${this.$t('Ознакомлен')}: ${this.formatDate(member.SignDate)}` : "")}`
                }))
            ).sort(function (a, b) { return a.name.localeCompare(b.name)});
        }
    },
    methods: {
        formatDate (source) {
            return this.$moment(source).format('DD.MM.YYYY HH:mm:ss');
        },
    }
}
</script>